import Big from 'big.js'

/**
 * Converts a monetary amount to its smallest unit by multiplying it by 10000 and rounding it.
 *
 * @param {number} amount - The monetary amount to be converted.
 * @returns {number} The converted amount in the smallest unit.
 */
export const apiMoney = (amount) => Math.round(amount * 10000)

/**
 * Divides the given value by 10,000.
 *
 * @param {number|string} value - The value to be divided. Can be a number or a string that can be parsed into a number.
 * @returns {number} The result of the division. Returns 0 if the input value is falsy.
 */
export const divide10k = (value) => (value ? parseFloat(value) / 10000 : 0)

/**
 * 计算从 n 乘到 m 的积，m 为1 即可算阶乘
 * @param  {Number} n [description]
 * @param  {Number} m [description]
 * @return {Number}   [description]
 */
export function factorial(n, m = 1, total = 1) {
  if (n === 1) return total
  if (n <= m) return n * total
  return factorial(n - 1, m, n * total)
}

/**
 * 数学组合计算
 * @param  {Number} n [description]
 * @param  {Number} m [description]
 * @return {Number}   [description]
 */
export function combine(n, m = 1) {
  if (n < m) return 0
  return (factorial(n, n - m + 1) / factorial(m)).toFixed()
}

/**
 * Sums all the numbers in an array.
 *
 * @param {number[]} arr - The array of numbers to sum.
 * @returns {number} The sum of all the numbers in the array.
 */
export const sumArray = (arr) => arr.reduce((num, cur) => Big(num).plus(cur).toNumber(), 0)

/**
 * Calculates the sum of two numbers using the Big.js library.
 *
 * @param {number} a - The first number to add.
 * @param {number} b - The second number to add.
 * @returns {number} The sum of the two numbers.
 */
export const sum = (a, b) => Big(a).plus(b).toNumber()

/**
 * Multiplies two numbers and returns the result as a number.
 *
 * @param {number} a - The first number to multiply.
 * @param {number} b - The second number to multiply.
 * @returns {number} The result of the multiplication.
 */
export const multiply = (a, b) => Big(a).times(b).toNumber()
